import { Injectable } from '@angular/core';
import { QueryEntity, QueryConfig, Order } from '@datorama/akita';
import { Observable } from 'rxjs';
import { CardStore, CardState } from './card.store';
import { Card } from './models/card.model';

@Injectable({ providedIn: 'root' })
@QueryConfig({ sortBy: 'MemberId', sortByOrder: Order.ASC })
export class CardQuery extends QueryEntity<CardState> {
  constructor(protected store: CardStore) {
    super(store);
  }

  /** All Cards. */
  selectCards(): Observable<Card[]> {
    return this.selectAll();
  }
}